export default "__VITE_ASSET__DuJV_QrC__"